<template>
  <div>
    <div class="curriculum_list"
         v-if="list && list.length!=0">
      <div class="curriculum_item"
           :style="{'width':'calc((100% - 120px) /'+ 4 +')'}"
           v-for="(item,index) in list"
           :key="index"
           @click="toDetails(item)">
        <el-image style="width:100%; height: 168px;border-radius: 10px 10px 0 0;"
                  :src="item.bannerUrl"></el-image>
        <div class="curriculum_item_box">
          <div class="curriculum_item_title">{{item.name.length>26?item.name.slice(0,25)+'...':item.name}}</div>
          <div>{{ item.shortIntro.length>26?item.shortIntro.slice(0,25)+'...':item.shortIntro }}</div>
          <div class="bottom">
            <span class="price">¥{{ item.price?item.price:0 }}</span>
            <s class="scribingPrice">¥{{ item.scribingPrice?item.scribingPrice:0 }}</s>

          </div>
          <!-- <div class="curriculum_item_center">
            <div class="l">章节:{{item.chapterCount}}节</div>
            <div class="l"
                 v-if="item.studyCount && item.studyCount>0">学习人数:{{item.studyCount}}</div>
            <div class="l"
                 v-if="item.totalSpan && item.totalSpan>0">时长：{{convertTime(item.totalSpan)}}</div>
          </div> -->
          <!-- <div class="lecturer">讲师：王波 | 生鲜实战专家</div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: { return: [] }
    }
  },
  methods: {
    toDetails (item) {
      this.$router.push('/techDetail?id=' + item.id + '&name=' + item.name)
    }
  }

}
</script>
<style lang="less" scoped>
.curriculum_list {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  .curriculum_item {
    // width: calc((100% - 120px) / 4);
    border-radius: 10px;
    margin-right: 40px;
    margin-bottom: 30px;
    background-color: #fff;
    position: relative;
    padding-bottom: 20px;
    cursor: pointer;
    .bottom {
      position: absolute;
      bottom: 10px;
      left: 10px;
    }
    .cove {
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .curriculum_item_box {
      padding: 20px 10px;
      box-sizing: border-box;
      .price {
        color: red;
        font-weight: bold;
        margin-right: 10px;
      }
      .scribingPrice {
        color: #999;
      }
      .lecturer {
        color: #666666;
        font-size: 12px;
      }
      .curriculum_item_center {
        display: flex;
        margin: 15px 0 0 0;
        flex-wrap: wrap;
        .l {
          background-color: #f2f4f7;
          color: '#333333';
          font-size: 12px;
          padding: 6px 8px;
          box-sizing: border-box;
          border-radius: 12px;
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
      .curriculum_item_title {
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        font-size: 18px;
        font-weight: 600;
        height: 60px;
        color: #333;
      }
    }
  }
  .curriculum_item:nth-child(4) {
    margin-right: 0;
  }
  .curriculum_item:nth-child(8) {
    margin-right: 0;
  }
  .curriculum_item:nth-child(12) {
    margin-right: 0;
  }
}
</style>